import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { OnHoldSubscriptionListProps } from "./types";
import Tooltip from "../../../../../../components/Tooltip";
import Icon from "../../../../../../components/Icon";
import { IconName } from "../../../../../../components/Icon/types";
import { PaymentMethodInfo } from "../../../PaymentMethodInfo/PaymentMethodInfo";
import { SUBSCRIPTION_STATUS } from "../../../../../../utils/common/contants";
import { selectCurrentSPS } from "../../../../../../store/metadata";

export const OnHoldSubscriptionDetail: FC<OnHoldSubscriptionListProps> = ({
  paymentMethod,
  currentSubscription,
  paymentMethodIconName,
  isAccountOverviewTab,
}) => {
  const { t } = useTranslation();
  const currentSPS = useSelector(selectCurrentSPS);
  const isShowPaymentMethod =
    !isAccountOverviewTab && (paymentMethod || currentSPS);

  return (
    <dl className="ams-active-subscription__details">
      <dt className="ams-active-subscription__details-label">{t("status")}</dt>
      <dd className="ams-active-subscription__details-value ams-active-subscription__status--success">
        {t(`subscriptionStatus.${SUBSCRIPTION_STATUS.onHold}`)}
        <Tooltip
          showOnClick
          placement="right"
          skidding={30}
          activator={<Icon>{"help" as IconName}</Icon>}
        >
          {t("onHoldTooltip")}
        </Tooltip>
      </dd>

      {isShowPaymentMethod && (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("paymentMethod")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            <PaymentMethodInfo
              paymentMethod={paymentMethod}
              paymentMethodIconName={paymentMethodIconName}
            />
          </dd>
        </>
      )}

      {currentSubscription.currentSKU?.sp.name ? (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("plan")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            {currentSubscription.currentSKU?.sp.name}
          </dd>
        </>
      ) : null}
    </dl>
  );
};
